import { apiClient } from './client';

/**
 * The business's leads (backend /crm/leads): sales and the call centre see their own tenant's
 * leads, a platform ADMIN every tenant's. Calls, notes and status changes come back as the
 * lead's `activities`; the next call is `lead.nextCallAt`.
 */

/** { items, meta } — params: status ('OPEN' | a status), assignedTo ('me' | 'none' | id),
 *  due ('now' | 'today' | 'upcoming' | 'unscheduled'), search, courseId, source, sort, page, limit */
export async function getLeads(params = {}) {
  const { data } = await apiClient.get('/crm/leads', { params });
  return data;
}

/** { total, open, byStatus, mine, unassigned, dueNow, dueToday, unscheduled, conversionRate } */
export async function getLeadSummary() {
  const { data } = await apiClient.get('/crm/leads/summary');
  return data;
}

/** Staff who can own a lead: [{ id, name, avatar, crmRole }] */
export async function getLeadAssignees() {
  const { data } = await apiClient.get('/crm/leads/assignees');
  return Array.isArray(data) ? data : [];
}

/**
 * The business's published courses, for the lead's course field: [{ id, title }]. Sales and the
 * call centre cannot read /courses/admin, so this route exists for them.
 */
export async function getLeadCourses() {
  const { data } = await apiClient.get('/crm/leads/courses');
  return Array.isArray(data) ? data : [];
}

/** { lead, activities } */
export async function getLead(id) {
  const { data } = await apiClient.get(`/crm/leads/${id}`);
  return data;
}

export async function createLead(body) {
  const { data } = await apiClient.post('/crm/leads', body);
  return data;
}

/** Edit details, status, owner (assignedToId, null clears) or the next call (nextCallAt, null clears). */
export async function updateLead(id, body) {
  const { data } = await apiClient.patch(`/crm/leads/${id}`, body);
  return data;
}

/** { outcome, note?, nextCallAt?, status? } -> the updated { lead, activities } */
export async function logLeadCall(id, body) {
  const { data } = await apiClient.post(`/crm/leads/${id}/calls`, body);
  return data;
}

export async function addLeadNote(id, note) {
  const { data } = await apiClient.post(`/crm/leads/${id}/notes`, { note });
  return data;
}

/** -> { lead, activities, userId, accountCreated } */
export async function convertLead(id) {
  const { data } = await apiClient.post(`/crm/leads/${id}/convert`);
  return data;
}
